<template>
  <component :is="component" class="dashboard-card" :to>
    <slot />
  </component>
</template>

<script setup lang="ts">
const props = defineProps<{
  to?: string;
}>();

const component = props.to ? resolveComponent("NuxtLink") : "div";
</script>

<style>
.dashboard-card {
  @apply bg-white rounded-xl px-6 py-5 border border-gray-200 shadow-md dark:bg-zinc-900
      dark:border-zinc-700 dark:hover:border-blue-400 overflow-auto;

  h1 {
    @apply mb-6 text-lg font-extrabold tracking-tight leading-none dark:text-blue-400;
  }

  input,
  textarea,
  select {
    @apply bg-zinc-850 !important;
  }
}
</style>
